import React from 'react';

const ListItem = ({ address, onSelectAddress, handleRemoveAddress }) =>
  (address && (
    <li className="padding d-flex justify-content-between align-items-center">
      <a
        className="d-flex justify-content-between align-items-center flex-grow-1"
        href="javascript: void(0)"
        onClick={() => onSelectAddress(address.id)}
      >
        <div>
          {(address.title && (
            <h5>
              {address.title}
              <span className="hide-xs">
                <i>Edit</i>
              </span>
            </h5>
          )) || <noscript />}
          <p className="small-label">
            {address.addressLine1} {address.postalCode}
          </p>
        </div>
      </a>
      <a
        href="javascript: void(0)"
        onClick={() => handleRemoveAddress(address.id)}
      >
        <i className="icon icon-trash" />
      </a>
    </li>
  )) || <noscript />;

export default ListItem;
